import React from "react";
import { useTranslation } from "react-i18next";
import { useRetrieveProjectsTags } from "@planzone/view-models";
import { Tag as T } from "@planzone/dto";

import { TagIcon } from "@common/assets/tagIcon";
import { Loader } from "../loader";
import { Section } from "../section";
import { ScrollPane } from "../scrollPane";
import { filterSearch } from "../utils";
import { Props } from "./types";
import { Tag } from "./tag";
import styles from "./styles.scss";

function ProjectsTags({ search, filter, setFilter, isOpen }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    tags,
    retrieveProjectsTags,
  } = useRetrieveProjectsTags();
  const selectTag = (tag: T) => setFilter(filter ? [...filter, tag] : [tag]);
  const unSelectTag = ({ name }: T) =>
    filter && setFilter(filter.filter((tag) => tag.name !== name));

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectsTags();
  }, []);

  return (
    <Section
      header={
        <div className={styles.header}>
          <TagIcon className={styles.icon} />
          <p className={styles.title}>
            {t("common.filterMenu.projectsTags.title")}
          </p>
        </div>
      }
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              [...filterSearch(tags, search)]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((tag) => (
                  <Tag
                    key={tag.name}
                    tag={tag}
                    isSelected={
                      !!filter && !!filter.find(({ name }) => name === tag.name)
                    }
                    select={() => selectTag(tag)}
                    unSelect={() => unSelectTag(tag)}
                  />
                ))
            ) : (
              <Loader />
            )}
          </div>
        </ScrollPane>
      }
      isOpen={isOpen}
    />
  );
}

export { ProjectsTags };
